exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download_file-name_1ae0K {\n    font-family: monospace;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n    word-wrap: break-word;\n}\n.download_file-name_1ae0K::before {\n    content: '\"';\n}\n.download_file-name_1ae0K::after {\n    content: '\"';\n}\n.download_name_1dXN3 {\n\n}\n.download_dot_1GvC1 {\n\n}\n.download_extension_15MbY {\n    text-decoration: underline;\n}", ""]);

// exports
exports.locals = {
	"file-name": "download_file-name_1ae0K",
	"fileName": "download_file-name_1ae0K",
	"name": "download_name_1dXN3",
	"dot": "download_dot_1GvC1",
	"extension": "download_extension_15MbY"
};